import {
  ArrayPath,
  getArrayPath,
  getStringPath,
  pathStartsWith,
} from '@the-platform-company/path-utilities'
import { GLOBAL_PREFIXES, PATH_MODE } from './constants'
import { IEventLike } from './types'

export const getStatePath = (
  path: string | ArrayPath,
  namespace: string
): string | ArrayPath => {
  // global state paths do not get a prefix
  if (
    GLOBAL_PREFIXES.some((prefix) => pathStartsWith(path, prefix, PATH_MODE)) ||
    pathStartsWith(path, namespace, PATH_MODE)
  ) {
    return path
  }

  return getStringPath(
    [
      namespace,
      ...(Array.isArray(path) ? path : getArrayPath(path, PATH_MODE)),
    ],
    PATH_MODE
  )
}

export const normalizeArray = <T = unknown>(
  input: T[]
): undefined | T | T[] => {
  return Array.isArray(input) && input.length === 1
    ? input[0]
    : Array.isArray(input) && input.length === 0
    ? undefined
    : input
}

export const isEventLike = (value: unknown): value is IEventLike => {
  if (value === null || typeof value !== 'object') {
    return false
  }

  const event = value as IEventLike

  return (
    event?.target != undefined &&
    event?.stopPropagation != undefined &&
    typeof event?.stopPropagation === 'function'
  )
}
